import type { Location } from 'react-router-dom'

/** Query parameter carrying the in-app page to return to after signing in or creating an account. */
const kAuthRedirectParam = 'redirect'

export function signInPathFor(location: Pick<Location, 'pathname' | 'search' | 'hash'>): string {
  const returnPath = `${location.pathname}${location.search}${location.hash}`
  return `/sign-in?${kAuthRedirectParam}=${encodeURIComponent(returnPath)}`
}

/**
 * The page to return to from the `redirect` query parameter, or null when it is missing or not an
 * in-app path. `//host` and `/\host` are rejected because browsers resolve both to another site.
 */
export function authRedirectPathFrom(searchParams: URLSearchParams): string | null {
  const redirect = searchParams.get(kAuthRedirectParam)
  if (redirect == null || !redirect.startsWith('/') || redirect.startsWith('//') || redirect.startsWith('/\\')) {
    return null
  }
  return redirect
}

export function signUpPathFor(redirectPath: string | null): string {
  return redirectPath == null ? '/sign-up' : `/sign-up?${kAuthRedirectParam}=${encodeURIComponent(redirectPath)}`
}
